export default __webpack_public_path__ + "static/media/pikachu-ninja.9b6b226f.jpg";